import { DESKTOP_HARDCODE_LINKS } from 'constants/links';

import { InferValueTypes } from 'types/commonTypes';

import isMobile from '../../helpers/isMobile';

import * as action from './actions';
import * as actionTypes from './actionTypes';

export const initialState = {
    url: '',
};

type ActionType = ReturnType<InferValueTypes<typeof action>>;

const DEFAULT_LINK = isMobile.android() ? DESKTOP_HARDCODE_LINKS.GOOGLE : DESKTOP_HARDCODE_LINKS.APPLE;

const deepLinkReducer = (state = initialState, action: ActionType) => {
    switch (action.type) {
        case actionTypes.GET_DEEP_LINK_SUCCESS:
            return { ...state, url: action.payload };

        case actionTypes.GET_DEEP_LINK_ERROR:
            return { ...state, url: DEFAULT_LINK };

        default:
            return state;
    }
};

export default deepLinkReducer;
